import SkeletonAnim from './SkeletonAnim';

export default SkeletonAnim;
